var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_7851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 8.125H18.125V4.375",
    stroke: "#888A93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7187 15.0003C13.7359 15.9277 12.5016 16.5449 11.1701 16.7748C9.83853 17.0047 8.46875 16.8371 7.2319 16.293C5.99504 15.7488 4.94596 14.8523 4.21573 13.7153C3.4855 12.5784 3.1065 11.2515 3.12609 9.90034C3.14568 8.54923 3.56298 7.23385 4.32586 6.11855C5.08875 5.00325 6.16338 4.13749 7.41548 3.62944C8.66759 3.1214 10.0417 2.99359 11.366 3.262C12.6903 3.5304 13.9062 4.18311 14.8617 5.13858L18.1249 8.1253",
    stroke: "#888A93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_7851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshicon);
export default __webpack_public_path__ + "static/media/refreshicon.976a3c32531c098f7dde01761800202b.svg";
export { ForwardRef as ReactComponent };